import React from 'react'
import { useTranslation } from 'react-i18next'
import { correspondentService } from '../../services/correspondent.service'
import { Correspondent } from '../../types'
import { formatDate } from '../../utils/dateFormatter'
import { ManagementList } from '../common/ManagementList'
import { CorrespondentEditDialog } from './CorrespondentEditDialog'

export const CorrespondentList: React.FC = () => {
  const { t } = useTranslation()

  const getDeleteMessage = (object: Correspondent) => {
    return t('confirm_delete_correspondent', { name: object.name })
  }

  const extraColumns = [
    {
      key: 'last_correspondence',
      name: t('last_used'),
      valueFn: (correspondent: Correspondent) => {
        if (correspondent.last_correspondence) {
          const date = new Date(correspondent.last_correspondence)
          if (date.toString() === 'Invalid Date') {
            // Handle very old date strings that can't be parsed
            const fixedDate = new Date(correspondent.last_correspondence?.toString().replace(/([-+])(\d\d):\d\d:\d\d/gm, `$1$2:00`))
            return formatDate(fixedDate.toISOString())
          }
          return formatDate(date.toISOString())
        }
        return ''
      },
    },
  ]

  return (
    <ManagementList
      service={correspondentService}
      editDialogComponent={CorrespondentEditDialog}
      typeName={t('correspondent')}
      typeNamePlural={t('correspondents')}
      permissionType="correspondent"
      extraColumns={extraColumns}
      getDeleteMessage={getDeleteMessage}
      info={t('correspondents_info')}
      infoLink="correspondents"
    />
  )
}
